
import initialTheme from "gatsby-theme-blog/src/gatsby-plugin-theme-ui"

import colors from "./colors-babotics"

export default {
  ...initialTheme,
  initialColorMode: `dark`,
  colors,
  sizes: {
    container: 920,
  },
}
